var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgYellowStar = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6.868 6.618-5.316.77-.095.02a.833.833 0 0 0-.366 1.403l3.851 3.75-.908 5.295-.01.092a.833.833 0 0 0 1.22.786l4.754-2.5 4.744 2.5.084.039a.833.833 0 0 0 1.126-.917l-.909-5.296 3.854-3.75.065-.07a.834.834 0 0 0-.528-1.35l-5.317-.772L10.741 1.8a.833.833 0 0 0-1.495 0L6.868 6.618Z",
    fill: "#FFB800"
  })));
};
export default SvgYellowStar;